import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.newdefault;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOAD_HOMEWORK_DATA: `${uid}.loadHomeworkData`,
    UPDATE_SCREEN_IN_BACKGROUND_ASYNC: `${uid}.updateScreenInBackgroundAsync`,
    UPDATE_SCREEN_IN_BACKGROUND_SUCCESS: `${uid}.updateScreenInBackgroundSuccess`,
    UPDATE_SCREEN_IN_BACKGROUND_FAILURE: `${uid}.updateScreenInBackgroundFailure`,
};

export { ActionTypes };